import React, { useRef, useState, useEffect } from 'react';
import EntitiesList from '../home/EntitiesList';
import TerritoryStats from '../../common/Stats/Territory';
import VendorsWidget from '../home/VendorsWidget';
import ScrollButtons from '../../common/ScrollButtons';

const MemoEntitiesList = React.memo(EntitiesList);
const MemoTerritoryStats = React.memo(TerritoryStats);
const MemoVendorsWidget = React.memo(VendorsWidget);

const renderWidget = (metric, entity, sharedMode) => {
	const { entity: entityType, id, title, dateStart, dateEnd } = entity;

	switch (metric) {
		case 'products':
			return <MemoEntitiesList key={id} trends={true} title="Top Products" entity="products" dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} parentEntity={entityType} parentEntityIDs={id} parentEntityName={title} addTotal={true} externalLinks={!sharedMode} />;
		case 'artists':
			return <MemoEntitiesList key={id} trends={true} title="Top Artists" entity="artists" dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} parentEntity={entityType} parentEntityIDs={id} parentEntityName={title} addTotal={true} externalLinks={!sharedMode} />;
		case 'tracks':
			return <MemoEntitiesList key={id} trends={true} title="Top Tracks" entity="tracks" dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} parentEntity={entityType} parentEntityIDs={id} parentEntityName={title} externalLinks={!sharedMode} />;
		case 'territories':
			return <MemoTerritoryStats key={id} dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} entity={entityType} ids={id} parentEntityName={title} comparison={true} />;
		case 'vendors':
			return <MemoVendorsWidget key={id} dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} entity={entityType} id={id} parentEntityName={title} comparison={true} />;
		default:
			return null;
	}
};

const ComparisonRow = ({ entities, metric, sharedMode }) => {
	const containerRef = useRef(null);
	const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;

		const check = () => setHasHorizontalScroll(el.scrollWidth > el.clientWidth);

		check();

		let resizeObserver = null;
		if (window.ResizeObserver) {
			resizeObserver = new ResizeObserver(() => check());
			resizeObserver.observe(el);
		} else {
			window.addEventListener('resize', check);
		}

		return () => {
			if (resizeObserver) resizeObserver.disconnect();
			else window.removeEventListener('resize', check);
		};
	}, [entities, metric]);

	return (
		<div>
			{hasHorizontalScroll && containerRef.current && <ScrollButtons el={containerRef.current} />}
			<div ref={containerRef} className={`comparison-row comparison-row-${metric}`}>
				{entities.map(entity => renderWidget(metric, entity, sharedMode))}
			</div>
		</div>
	);
};

export default ComparisonRow;